export enum PurchaseOperationSubtype {
    default = "default",
    lite = "lite",
    wallet = "wallet",
}
